<nz-card [nzTitle]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.TITLE' | translate">
  <nz-spin [nzSpinning]="isLoading || isSaving">
    <p class="subtitle">{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DESCRIPTION' | translate }}</p>

    <nz-alert
      *ngIf="!isBusinessPlan"
      nzType="info"
      nzShowIcon
      [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.BUSINESS_REQUIRED' | translate"
      [nzDescription]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.BUSINESS_REQUIRED_DESCRIPTION' | translate"
      class="status-alert"
    ></nz-alert>

    <ng-container *ngIf="!domain; else configuredDomain">
      <form nz-form nzLayout="vertical" [formGroup]="domainForm" class="domain-form">
        <nz-form-item>
          <nz-form-label>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.HOSTNAME_LABEL' | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.HOSTNAME_REQUIRED' | translate">
            <span nz-tooltip [nzTooltipTitle]="!isBusinessPlan ? ('ACCOUNT_SETTINGS.BRANDED_DOMAIN.BUSINESS_REQUIRED' | translate) : null">
              <input nz-input formControlName="hostname" [disabled]="!canManage" [placeholder]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.HOSTNAME_PLACEHOLDER' | translate" />
            </span>
          </nz-form-control>
        </nz-form-item>
        <nz-alert
          nzType="info"
          nzShowIcon
          [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DOMAIN_GUIDANCE_TITLE' | translate"
          [nzDescription]="domainGuidance"
          class="status-alert"
        ></nz-alert>
        <ng-template #domainGuidance>
          <p>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DOMAIN_GUIDANCE_UNUSED_ROOT' | translate }}</p>
          <p>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DOMAIN_GUIDANCE_WEBSITE_ROOT' | translate }}</p>
          <p>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DOMAIN_GUIDANCE_UNRELATED_RECORDS' | translate }}</p>
        </ng-template>
        <div class="actions">
          <ng-container *ngIf="isCompanyAdmin; else readOnlyManagement">
            <button nz-button nzType="primary" type="button" (click)="connect()" [disabled]="!canManage || domainForm.invalid || isSaving">
              {{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.CONNECT' | translate }}
            </button>
            <button *ngIf="canRequestUpgrade" nz-button type="button" (click)="openUpgrade()">
              {{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.UPGRADE' | translate }}
            </button>
          </ng-container>
        </div>
      </form>
    </ng-container>

    <ng-template #configuredDomain>
      <div class="domain-header">
        <div>
          <strong>{{ domain?.hostname }}</strong>
          <div class="example-url">{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DOMAIN_USAGE' | translate:{ hostname: domain?.hostname } }}</div>
        </div>
        <nz-tag [nzColor]="statusColor">{{ statusKey | translate }}</nz-tag>
      </div>

      <nz-alert
        *ngIf="domain?.status === 'pending' || domain?.status === 'verifying'"
        nzType="info"
        nzShowIcon
        [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.VERIFICATION_PENDING' | translate"
        [nzDescription]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.SCANAFY_FALLBACK' | translate"
        class="status-alert"
      ></nz-alert>
      <nz-alert
        *ngIf="domain?.status === 'failed'"
        nzType="error"
        nzShowIcon
        [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.VERIFICATION_FAILED' | translate"
        [nzDescription]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.VERIFICATION_FAILED_DESCRIPTION' | translate"
        class="status-alert"
      ></nz-alert>
      <nz-alert
        *ngIf="domain?.status === 'disabled'"
        nzType="warning"
        nzShowIcon
        [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DISABLED' | translate"
        [nzDescription]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.SCANAFY_FALLBACK' | translate"
        class="status-alert"
      ></nz-alert>

      <section *ngIf="domain?.requiredDnsRecords?.length" class="dns-records">
        <h3>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_TITLE' | translate }}</h3>
        <p>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_DESCRIPTION' | translate }}</p>
        <nz-table #dnsTable [nzData]="domain?.requiredDnsRecords || []" [nzShowPagination]="false" nzSize="small">
          <thead><tr><th>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_ACTION' | translate }}</th><th>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_NAME' | translate }}</th><th>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_TYPE' | translate }}</th><th>{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DNS_VALUE' | translate }}</th></tr></thead>
          <tbody><tr *ngFor="let record of dnsTable.data"><td>{{ dnsActionLabel(record.action) }}</td><td>{{ record.name }}</td><td>{{ record.type }}</td><td class="dns-value">{{ record.value }}</td></tr></tbody>
        </nz-table>
      </section>

      <div class="actions">
        <ng-container *ngIf="isCompanyAdmin; else readOnlyManagement">
          <button *ngIf="domain?.status === 'failed'" nz-button nzType="primary" type="button" (click)="retry()" [disabled]="!canManage">
            {{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.RETRY' | translate }}
          </button>
          <button nz-button nzType="default" type="button" (click)="refresh()" [disabled]="!canManage">
            {{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.REFRESH' | translate }}
          </button>
          <button
            nz-button nzDanger type="button"
            nz-popconfirm
            [nzPopconfirmTitle]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DISCONNECT_CONFIRM' | translate"
            (nzOnConfirm)="disconnect()"
            [disabled]="!canManage"
          >{{ 'ACCOUNT_SETTINGS.BRANDED_DOMAIN.DISCONNECT' | translate }}</button>
        </ng-container>
      </div>
    </ng-template>
    <ng-template #readOnlyManagement>
      <nz-alert
        nzType="info"
        nzShowIcon
        [nzMessage]="'ACCOUNT_SETTINGS.BRANDED_DOMAIN.READ_ONLY_MANAGEMENT' | translate:{ role: ('ROLES.COMPANY_ADMIN' | translate) }"
      ></nz-alert>
    </ng-template>
  </nz-spin>
</nz-card>
